import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-brand-rule/70 bg-brand-cream" data-testid="site-footer">
      <div className="container-narrow py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Link to="/" aria-label="Quantum Results — home" className="inline-block">
              <Logo className="h-14 w-auto" />
            </Link>
            <p className="mt-4 text-[14px] leading-relaxed text-brand-ink/65 max-w-sm">
              Thoughtful experiences that help people slow down, think more
              clearly, and discover their next meaningful step forward.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-4">Experiences</div>
            <ul className="space-y-2 text-[14px] text-brand-ink/75">
              <li><Link className="hover:text-brand-blue" to="/four-levels">The Four Levels</Link></li>
              <li><Link className="hover:text-brand-blue" to="/pattern-reveal">Pattern Reveal</Link></li>
              <li><Link className="hover:text-brand-blue" to="/weekly-quantum-edge">Weekly Quantum Edge</Link></li>
              <li><Link className="hover:text-brand-blue" to="/forward-reset">Forward Reset</Link></li>
              <li><Link className="hover:text-brand-blue" to="/daily-quantum-edge">Daily Quantum Edge</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4">Quantum Results</div>
            <ul className="space-y-2 text-[14px] text-brand-ink/75">
              <li><Link className="hover:text-brand-blue" to="/about">About Dan</Link></li>
              <li><Link className="hover:text-brand-blue" to="/resources">Resources</Link></li>
              <li><Link className="hover:text-brand-blue" to="/contact">Contact</Link></li>
              <li>
                <a className="hover:text-brand-blue" href="mailto:info@quantumresults.com">
                  info@quantumresults.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-brand-rule/60 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-brand-ink/55">
          <div>© {new Date().getFullYear()} Quantum Results LLC. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link className="hover:text-brand-ink" to="/privacy" data-testid="footer-privacy">Privacy</Link>
            <Link className="hover:text-brand-ink" to="/terms" data-testid="footer-terms">Terms</Link>
            <Link className="hover:text-brand-ink" to="/admin/login" data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
